export const CREATE_USER_REQUEST = 'user/CREATE_USER_REQUEST';
export const CREATE_USER_SUCCESS = 'user/CREATE_USER_SUCCESS';
export const CREATE_USER_FAILURE = 'user/CREATE_USER_FAILURE';

export const READ_USER_REQUEST = 'user/READ_USER_REQUEST';
export const READ_USER_SUCCESS = 'user/READ_USER_SUCCESS';
export const READ_USER_FAILURE = 'user/READ_USER_FAILURE';

export const UPDATE_USER_REQUEST = 'user/UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'user/UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILURE = 'user/UPDATE_USER_FAILURE';

export const DELETE_USER_REQUEST = 'user/DELETE_USER_REQUEST';
export const DELETE_USER_SUCCESS = 'user/DELETE_USER_SUCCESS';
export const DELETE_USER_FAILURE = 'user/DELETE_USER_FAILURE';

export const READ_USERS_REQUEST = 'user/READ_USERS_REQUEST';
export const READ_USERS_SUCCESS = 'user/READ_USERS_SUCCESS';
export const READ_USERS_FAILURE = 'user/READ_USERS_FAILURE';

export const VALIDATE_EMAIL_TOKEN_REQUEST = 'user/VALIDATE_EMAIL_TOKEN_REQUEST';
export const VALIDATE_EMAIL_TOKEN_SUCCESS = 'user/VALIDATE_EMAIL_TOKEN_SUCCESS';
export const VALIDATE_EMAIL_TOKEN_FAILURE = 'user/VALIDATE_EMAIL_TOKEN_FAILURE';

export const CHANGE_PASSWORD_REQUEST = 'user/CHANGE_PASSWORD_REQUEST';
export const CHANGE_PASSWORD_SUCCESS = 'user/CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAILURE = 'user/CHANGE_PASSWORD_FAILURE';

export const RESET_PASSWORD_REQUEST = 'user/RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'user/RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'user/RESET_PASSWORD_FAILURE';

export const INVALIDATE_USER = 'user/INVALIDATE_USER';


// WEBPACK FOOTER //
// ./src/modules/user/user.actionTypes.js